export enum DashboardEnum {
  origination = 'origination',
  engagement = 'engagement'
}
